// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3hdBD","paramInput":"JobSimulator_paramInput__1QeI2","input":"JobSimulator_input__11oZi"};